import { Group, NativeSelect } from '@mantine/core';

type Props = {
  year: number;
  setYear: (year: number) => void;
  month: number;
  setMonth: (month: number) => void;
};

export function MonthSelector({ year, setYear, month, setMonth }: Props) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2023 }, (_, i) => (2024 + i).toString());
  const months = (() => {
    if (year === 2024) {
      return ['10', '11', '12'];
    }
    if (year === currentYear) {
      return Array.from({ length: new Date().getMonth() + 1 }, (_, i) => (i + 1).toString());
    }
    return Array.from({ length: 12 }, (_, i) => (i + 1).toString());
  })();

  return (
    <Group>
      <NativeSelect
        label="年"
        data={years}
        value={`${year}`}
        onChange={(ev) => setYear(parseInt(ev.currentTarget.value))}
      ></NativeSelect>
      <NativeSelect
        label="月"
        data={months}
        value={`${month}`}
        onChange={(ev) => setMonth(parseInt(ev.currentTarget.value))}
      ></NativeSelect>
    </Group>
  );
}
